export default __webpack_public_path__ + "static/media/Loader.6271c636.gif";